import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getMaterials } from "@/services/propsApi";
import { AutoComplete, Button } from "antd";

const Component = (props: any) => {
  const { type,initValue } = props;
  const [source, setSource] = useState<any>(null);
  const [inputValue, setInputValue] = useState<any>(null);

  const history = useNavigate();

  useEffect(() => {
    getMaterials({}).then((r) => {
      setSource(
        r.data.response.data.map((item: any) => {
          return {
            label: `${item.Name_ZH} ${item.Molecular_formula} ${item.cas}`,
            value: `${item.Name_ZH}${item.Molecular_formula}`,
            cas: item.cas,
          };
        })
      );
    });
  }, []);

  //输入查询字符的动作
  const handleSearch = (value: string) => {
    setInputValue(value);
    // buildOptions(value);
  };

  //选中动作
  const selectMaterial = (v: any, o: any) => {
    if (v) {
      history(`/info/${o.cas}`);
    }
  };

  return (
    <>
      {type === "index" ? (
        <div className="searchBar">
          <AutoComplete
            style={{ width: "100%" }}
            className="mt1"
            value={inputValue}
            onSearch={handleSearch}
            placeholder={<div style={{ fontSize: "2.2rem", marginLeft: "4rem" }}>{initValue?initValue:'输入物质名称'}</div>}
            options={source}
            onSelect={selectMaterial}
            
            filterOption={(inputValue: any, option: any) => {
              return option!.value?.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1;
            }}
          />
        </div>
      ) : (
        <div className="searchBar_normal">
          <AutoComplete
            style={{ width: "100%" }}
            value={inputValue}
            onSearch={handleSearch}
            placeholder={<div style={{ fontSize: "1.6rem",marginLeft: "3rem"}}>{initValue?initValue:'输入物质名称'}</div>}
            options={source}
            onSelect={selectMaterial}
            filterOption={(inputValue: any, option: any) => {
              return option!.value?.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1;
            }}
          />
        </div>
      )}
    </>
  );
};

export default Component;
